import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=2fb0bda6&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
